<template>
  <div ref="currentMasteryChart" class="w-full h-72 chart"></div>
</template>

<script>
import { ref, onMounted, watch } from "vue";
// import VChart from "vue-echarts";
import * as echarts from "echarts";
import i18n from "@/plugins/i18n";

export default {
  name: "TaskCompletionChart",
  props: {
    data: {
      type: Array,
      required: true,
    },
    months: {
      type: Array,
      required: true,
    },
  },
  setup(props, { emit }) {
    const currentMasteryChart = ref(null);

    const initChart = () => {
      if (!currentMasteryChart.value) {
        return;
      }
      
      const chart = echarts.init(currentMasteryChart.value);

      const maxLearners = Math.max(
        ...props.data.map((item) => item.totalLearners)
      );

      const option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        xAxis: {
          type: "category",
          data: (props.data || []).map((item) => {
            return item.week;
          }),
          axisLine: {
            lineStyle: {
              color: "#E4E7EB",
            },
          },
          axisLabel: {
            color: "#475467",
          },
          nameTextStyle: {
            fontWeight: "bold",
            fontSize: 12,
            padding: 20,
            color: "#475467",
          },
        },
        yAxis: {
          type: "value",
          max: maxLearners,
          axisLine: {
            lineStyle: {
              color: "#475467",
            },
          },
          axisLabel: {
            color: "#475467",
          },
          splitLine: {
            lineStyle: {
              color: "#F1F3F5",
            },
          },
          name: i18n.global.t("overview_page.students"),
          nameLocation: "middle",
          nameTextStyle: {
            fontWeight: "bold",
            fontSize: 12,
            padding: 15,
            color: "#475467",
          },
        },
        grid: {
          left: "4%",
          right: "4%",
          bottom: "12%",
          top: "5%",
          containLabel: true,
        },
        series: [
          {
            name: i18n.global.t("overview_page.tasks_completed"),
            type: "bar",
            stack: "tasks",
            data: (props.data || []).map((item) => item.students || 0),
            itemStyle: {
              borderRadius: [10, 10, 0, 0],
              color: function (params) {
                const colors = props.data.map((item) => item.color);
                return colors[params.dataIndex % colors.length];
              },
            },
            barWidth: "40%",
          },
        ],
      };

      chart.setOption(option);

      chart.on('click', (params) => {
        emit('taskCompletionLearners', params);
      });
    };

    onMounted(() => {
      if (props.data) {
        initChart();
      }
    });

    watch(
      () => props.data,
      () => {
        initChart();
      }
    );

    return {
      currentMasteryChart,
    };
  },
};
</script>
